import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';

// Global error handler to catch third-party library errors
window.addEventListener('error', (event) => {
  // Suppress errors from third-party libraries (like giveFreely, browser extensions, etc.)
  if (event.filename && (
    event.filename.includes('giveFreely') ||
    event.filename.includes('extension://') ||
    event.filename.includes('chrome-extension://') ||
    event.filename.includes('moz-extension://')
  )) {
    console.warn('[Third-party Error Suppressed]', event.filename, event.message);
    event.preventDefault(); // Prevent error from breaking the app
    return false;
  }
});

// Handle unhandled promise rejections
window.addEventListener('unhandledrejection', (event) => {
  // Suppress promise rejections from third-party libraries
  if (event.reason && typeof event.reason === 'object') {
    const errorString = JSON.stringify(event.reason);
    if (errorString.includes('giveFreely') || 
        errorString.includes('extension://') ||
        errorString.includes('chrome-extension://')) {
      console.warn('[Third-party Promise Rejection Suppressed]', event.reason);
      event.preventDefault(); // Prevent rejection from breaking the app
      return false;
    }
  }
  
  // Check error message for third-party indicators
  if (event.reason && typeof event.reason === 'string') {
    if (event.reason.includes('giveFreely')) {
      console.warn('[Third-party Promise Rejection Suppressed]', event.reason);
      event.preventDefault();
      return false;
    }
  }
});

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(<App />);